import {
  PTL_BULK_MIS,
  PTL_BULK_MIS_GET_TRANSPORTERS
} from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  response: null,
  transporters: null,
  loading: false
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case PTL_BULK_MIS[REQUEST]:
      return { ...state, response: null, loading: true };
    case PTL_BULK_MIS[SUCCESS]:
      return { ...state, response: action.response, loading: false };
    case PTL_BULK_MIS[FAILURE]:
      return { ...state, response: null, loading: false };
    case PTL_BULK_MIS_GET_TRANSPORTERS[REQUEST]:
      return { ...state, transporters: null, loading: true };
    case PTL_BULK_MIS_GET_TRANSPORTERS[SUCCESS]:
      return { ...state, transporters: action.response, loading: false };
    case PTL_BULK_MIS_GET_TRANSPORTERS[FAILURE]:
      return { ...state, transporters: null, loading: false };
    default:
      return state;
  }
}
